import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './Activities.css';

const Activities = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['उपक्रम', 'शिशुमंदिर', 'वाचनालय', 'ग्रंथालय', 'अभ्यासिका', 'शिवण वर्ग', 'व्यायामशाळा'],
    en: ['activities', 'children home', 'reading room', 'library', 'study room', 'sewing class', 'gymnasium']
  });

  const pageHeaderData = {
    title: {
      marathi: 'उपक्रम',
      english: 'Activities'
    },
    subtitle: {
      marathi: 'मंडळाच्या विविध कल्याणकारी उपक्रम',
      english: 'Various welfare activities of the board'
    }
  };

  return (
    <div className="initiatives">
      <div className="initiatives-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="initiatives-content">
          {/* Activities Table */}
          <section className="initiatives-section">
            <div className="initiatives-table-container">
              <table className="initiatives-table">
                <thead>
                  <tr>
                    <th>
                      {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
                    </th>
                    <th>
                      {isMarathi() ? 'उपक्रम' : 'Activity'}
                    </th>
                    <th>
                      {isMarathi() ? 'परिपत्रक' : 'Circular'}
                    </th>
                    <th>
                      {isMarathi() ? 'फॉर्म' : 'Form'}
                    </th>
                    <th>
                      {isMarathi() ? 'दिनांक' : 'Date'}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '१' : '1'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'शिशुमंदिर' : 'Children\'s Home'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160406-shishumandir-paripatrak.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160406-shishumandir-form.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-date">
                      {isMarathi() ? '०६/०४/२०१६' : '06/04/2016'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '२' : '2'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'पाळणाघर' : 'Daycare'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160615-palanaghar-mahiti.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-na">NA</td>
                    <td className="initiative-date">
                      {isMarathi() ? '१५/०६/२०१६' : '15/06/2016'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '३' : '3'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'वाचनालय' : 'Reading Room'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160405-vachanaly-paripatrak.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-na">NA</td>
                    <td className="initiative-date">
                      {isMarathi() ? '०५/०४/२०१६' : '05/04/2016'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '४' : '4'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'ग्रंथालय' : 'Library'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20131019-granthalay-mahiti.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-na">NA</td>
                    <td className="initiative-date">
                      {isMarathi() ? '१९/१०/२०१३' : '19/10/2013'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '५' : '5'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'अभ्यासिका' : 'Study Room'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20141001-abhyasika-paripatrak.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20141001-abhyasika-form.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-date">
                      {isMarathi() ? '०१/१०/२०१४' : '01/10/2014'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '६' : '6'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'शिवण वर्ग (मंडळाचा शिवण वर्ग व सरकारमान्य शिवण वर्ग)' : 'Mandal\'s Sewing Class and Government Approved Sewing Class'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160406-shivanvarg-pariptrk.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160406-shivan-varg-hastvyavasay-varg-form.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-date">
                      {isMarathi() ? '०६/०४/२०१६' : '06/04/2016'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '७' : '7'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'हस्तव्यवसाय वर्ग' : 'Handicraft Class'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160406-hasta-vyavasay-varg-pariptrak.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20160406-shivan-varg-hastvyavasay-varg-form.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-date">
                      {isMarathi() ? '०६/०४/२०१६' : '06/04/2016'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="initiative-serial">
                      {isMarathi() ? '८' : '8'}
                    </td>
                    <td className="initiative-details">
                      {isMarathi() ? 'शासनमान्य ग्रंथपालन प्रमाणपत्र शिक्षण वर्ग' : 'Government Approved Library Science Certificate Course'}
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20180525-shasanmanya-granthapalan-pramanpatra-sikshanvarg-paripatrak.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-more-info">
                      <a href="https://mlwb.in/react-static-files/pdf/Initiatives/20180525-shasanmanya-granthapalan-pramanpatra-sikshanvarg-form.pdf" className="initiative-link" target="_blank" rel="noopener noreferrer" title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="initiative-date">
                      {isMarathi() ? '२५/५/२०१८' : '25/05/2018'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Other Activities Section */}
          <section className="initiatives-section">
            <h2 className="section-title">
              {isMarathi() ? 'अन्य उपक्रम' : 'Other Activities'}
            </h2>
            <div className="section-content">
              <div className="section-text">
                {isMarathi() ? (
                  <div>
                    <p>जागेच्या आणि प्रशिक्षकांच्या उपलब्धतेनुसार मंडळ स्थानिक स्तरावर काही उपक्रम राबविते. कामगार आणि त्याच्या कुटुंबियांना माफक दरात या सुविधांचा लाभ घेता येतो. इतर नागरिकही या सुविधांचा लाभ घेऊ शकतात.</p>
                    
                    <p>काही निवडक उपक्रम पुढीलप्रमाणे -</p>
                    
                    <ol>
                      <li><strong>जलतरण तलाव :</strong> कामगार क्रीडा भवन - मुंबई, कामगार कल्याण भवन, राजेरघुजीनगर- नागपूर आणि कामगार कल्याण भवन, सहकारनगर - पुणे या तीन प्रकल्पाच्या ठिकाणी जलतरण तलाव आहेत.</li>
                      
                      <li><strong>व्यायामशाळा :</strong> जागेच्या उपलब्धतेनुसार मंडळाच्या राज्यात १७ व्यायामशाळा आहेत. यात नाममात्र शुल्क आकारून प्रवेश दिला जातो. व्यायामशाळांमध्ये प्रशिक्षक देखील आहेत. कामगार कल्याण भवन, ललित कला भवन व काही प्रमुख कामगार कल्याण केंद्रांत या व्यायामशाळा आहेत.</li>
                      
                      <li><strong>बॅडमिंटन कोर्ट :</strong> मुंबई, पुणे, नागपूर येथे मंडळाचे बॅडमिंटन कोर्ट उपलब्ध आहेत.</li>
                      
                      <li><strong>टेबल टेनिस कोर्ट :</strong> मुंबई, पुणे, अकोला या ठिकाणी मंडळाचे टेबल टेनिस कोर्ट आहेत.</li>
                      
                      <li><strong>जिम्नॅस्टीक वर्ग :</strong> कामगार कल्याण भवन, राजेरघुजी नगर - नागपूर येथे सदर प्रशिक्षण वर्गाचे आयोजन केले जाते.</li>
                      
                      <li><strong>संगणक वर्ग :</strong> मुंबई, पुणे, नागपूर येथे संगणक प्रशिक्षण सुरु आहेत. रोजगाराच्या संधी उपलब्ध करून देणारे संगणक प्रोग्रामिंग, डाटाबेस मॅनेजमेंट सिस्टीम, टॅली, डीटीपी, कोरल ड्रॉ, फोटोशॉप, एमएस-सीआयटी आदी अभ्यासक्रम शिकविण्यात येतात.</li>
                      
                      <li><strong>ब्युटीपार्लर कोर्स :</strong> कामगार कुटुंबिय महिलांना रोजगाराची संधी उपलब्ध व्हावी या उद्देशाने हे वर्ग सुरु केले आहेत. ललित कला भवन, नायगाव येथे यशवंतराव चव्हाण मुक्त विद्यापीठाचा अभ्यासक्रमानुसार वर्ग सुरू आहे. कामगार कल्याण भवन, राजे रघुजीनगर येथे महाराष्ट्र राज्य व्यवसाय शिक्षण मंडळाचे वर्ग चालविले जातात. शिवाय, काही ठिकाणी ७५ टक्के व २५ टक्के तत्वावर विविध संस्थांच्या मार्फत वर्ग चालविण्यात येतात.</li>
                      
                      <li><strong>नृत्य वर्ग :</strong> मुबंईत कामगार क्रीडा भवन - एल्फिन्स्टन, कामगार कल्याण भवन - अभुदयनगर, काळाचौकी आणि अंधेरी, ललित कला भवन, सानेगुरुजी पथ - वरळी, नायगाव व ना.म.जोशी मार्ग येथे आणि औरंगाबाद विभागात कामगार कल्याण भवन - सेलू येथे नृत्य वर्ग चालविले जातात.</li>
                      
                      <li><strong>टेक्निकल इन्स्टिट्यूट अभ्यासक्रम :</strong> ललित कला भवन, सिडको - नाशिक येथे टेक गुरु मल्टीपर्पज इन्स्टिट्यूट यांच्या सहकार्याने ७५ : २५ तत्वावर हा वर्ग सुरु आहे. यात इलेक्ट्रीकल, ऑटो मोबाईल, कॉम्प्युटर सॉफ्टवेअर / हार्डवेअर, फिटर, सीएनसी प्रोग्रामिंग, फॅशन डिझायनिग, ब्युटीपार्लर, मोबाईल रेपेरिंग आदी प्रशिक्षण दिले जाते.</li>
                    </ol>
                  </div>
                ) : (
                  <div>
                    <p>Based on the availability of space and trainers, the board runs some activities at the local level. Workers and their families can avail these facilities at nominal rates. Other citizens can also benefit from these facilities.</p>
                    
                    <p>Some selected activities are as follows -</p>
                    
                    <ol>
                      <li><strong>Swimming Pool :</strong> Swimming pools are available at three project locations - Kamgar Krida Bhavan - Mumbai, Kamgar Kalyan Bhavan, Rajeraghujinagar - Nagpur and Kamgar Kalyan Bhavan, Sahakarnagar - Pune.</li>
                      
                      <li><strong>Gymnasium :</strong> There are 17 gymnasiums in the state of the board based on space availability. Entry is given by charging nominal fees. Trainers are also available in the gymnasiums. These gymnasiums are located at Kamgar Kalyan Bhavan, Lalit Kala Bhavan and some major Kamgar Kalyan centers.</li>
                      
                      <li><strong>Badminton Court :</strong> Board's badminton courts are available in Mumbai, Pune, Nagpur.</li>
                      
                      <li><strong>Table Tennis Court :</strong> Board's table tennis courts are located in Mumbai, Pune, Akola.</li>
                      
                      <li><strong>Gymnastics Class :</strong> This training class is organized at Kamgar Kalyan Bhavan, Rajeraghuji Nagar - Nagpur.</li>
                      
                      <li><strong>Computer Class :</strong> Computer training is running in Mumbai, Pune, Nagpur. Employment opportunity providing computer programming, database management system, tally, DTP, coral draw, photoshop, MS-CIT etc. courses are taught.</li>
                      
                      <li><strong>Beauty Parlor Course :</strong> These classes have been started with the objective of providing employment opportunities to women from worker families. Classes are running according to the curriculum of Yashwantrao Chavan Mukt Vidyapeeth at Lalit Kala Bhavan, Naigaon. Classes of Maharashtra State Vocational Education Board are conducted at Kamgar Kalyan Bhavan, Rajeraghujinagar. Besides, classes are conducted through various institutions on 75% and 25% basis at some places.</li>
                      
                      <li><strong>Dance Class :</strong> Dance classes are conducted in Mumbai at Kamgar Krida Bhavan - Elphinstone, Kamgar Kalyan Bhavan - Abhudaynagar, Kalachowki and Andheri, Lalit Kala Bhavan, Saneguruji Path - Worli, Naigaon and N.M. Joshi Marg and in Aurangabad division at Kamgar Kalyan Bhavan - Selu.</li>
                      
                      <li><strong>Technical Institute Course :</strong> This class is running at Lalit Kala Bhavan, SIDCO - Nashik in collaboration with Tech Guru Multipurpose Institute on 75:25 basis. Training is provided in electrical, auto mobile, computer software/hardware, fitter, CNC programming, fashion designing, beauty parlor, mobile repairing etc.</li>
                    </ol>
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Navigation Buttons */}
          <section className="initiatives-navigation">
            <div className="navigation-buttons">
              <Link to="/schemes" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'योजना' : 'Schemes'}
              </Link>
              <Link to="/programs" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17ZM17 21V10H13V6H7V19H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'कार्यक्रम' : 'Programs'}
              </Link>
              <Link to="/awards" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 18C13.1046 18 14 18.8954 14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 18.8954 10.8954 18 12 18Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'पुरस्कार' : 'Awards'}
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Activities;
